import React, { useState, useEffect } from 'react';
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormGroup,
  FormControlLabel,
  Switch,
} from '@mui/material';
import './table.scss';
import { toast } from 'react-toastify';
import axiosInstance from '../../../api/axios';
import { BASE_URL } from '../../../constants/apiConstants';

interface SiteData {
  sectorname: string;
  regionname: string;
  sitecode: string;
  sitename: string;
  isspecialsite: boolean;
}

interface SpecialSiteTableProps {
  sites: SiteData[];
}

const tableHead = [
  {
    name: "Sector",
  },
  {
    name: "Regions",
  },
  {
    name: "Site Code",
  },
  {
    name: "Site Name",
  },
  {
    name: "Action",
  },
];

const SpecialSiteTable: React.FC<SpecialSiteTableProps> = ({ sites }): JSX.Element => {
  const [data, setData] = useState<SiteData[]>([]);
  const userId = localStorage.getItem('userid');
  // Sync data state with sites prop on initial load or when sites prop changes
  useEffect(() => {
    setData(sites);
  }, [sites]);

  // API call to update special site status
  const updateSpecialSiteStatus = async (siteCode: string, isSpecialSite: boolean) => {
    const payload = {
      userid: userId,
      sitecode: siteCode,
      isspecialsite: isSpecialSite,
    };
    try {
      await axiosInstance.post(`${BASE_URL}/api/v1/AdminConfiguration/SaveUpdateSpecialSiteStatus`, payload);
      toast("Site updated successfully", { type: "success" });
    } catch (err) {
      console.log(err)
      toast("Failed to update the site", { type: "error" });
    }
  };

  const handleSwitchChange = (index: number) => {
    const updatedData = [...data];
    const updatedRow = { ...updatedData[index], isspecialsite: !updatedData[index].isspecialsite };
    // Update the state first
    updatedData[index] = updatedRow;
    setData(updatedData);
    // Now call the API with the correct value
    updateSpecialSiteStatus(updatedRow.sitecode, updatedRow.isspecialsite);

  };


  return (
    <FormGroup className="table-wrapper SpecialSiteTable">
      <TableContainer component={Paper} className="table-inner" sx={{ maxHeight: 422 }}>
        <MuiTable stickyHeader>
          <TableHead>
            <TableRow>
              {tableHead.map((col, index) => (
                <TableCell key={index}>{col.name}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length !== 0 ? (
              data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.sectorname}</TableCell>
                  <TableCell>{row.regionname}</TableCell>
                  <TableCell>{row.sitecode}</TableCell>
                  <TableCell>{row.sitename}</TableCell>
                  <TableCell>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={row.isspecialsite}
                          onChange={() => handleSwitchChange(index)}
                          className={row.isspecialsite ? 'active' : ''}
                        />
                      }
                      label={row.isspecialsite ? 'On' : 'Off'}
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={tableHead.length} className='grey-bg center'>No data found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </FormGroup>
  );
};

export default SpecialSiteTable;
